import axios from 'axios';
import { BACKEND_API } from '../configs/constants';
import { isEmpty } from '../utils/utils';
import cogoToast from 'cogo-toast';

const axiosInstance = axios.create({
  baseURL: BACKEND_API,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'multipart/form-data',
    'Access-Control-Allow-Origin': '*'
  }
});

export const getWithAxios = async (url: string) => {
  return await axiosInstance.get(url).then((response: any) => {
    return response;
  });
};

export const genericHandlerError = (error: any) => {
  if (error && (typeof error === 'object' ? !isEmpty(error) : true)) {
    cogoToast.error(error.message || error || 'Oops!, Something went wrong. Please try again later.', {
      position: 'top-right'
    });
    console.log(error);
  }
};
